import { captureMessage } from '@sentry/react';
import { generatePath } from 'react-router-dom';

import { organizationQueryKey } from '@cast/constants';

import { PRODUCT_BASE_PATHS } from '@cast/console-constants';

import { getClusterIdFromLink } from '../routingUtils';

const containerLiveMigrationRouteSegment = 'container-live-migration';
const PERSISTENT_QUERY_PARAMS = [
  organizationQueryKey,
  'date_preset',
  'date_from',
  'date_to',
  'timezone',
];

const getDynamicContainerLiveMigrationRoutePath = () =>
  `${PRODUCT_BASE_PATHS.automation}/external-clusters/:clusterId/${containerLiveMigrationRouteSegment}`;

type ContainerLiveMigrationLinkArgs = {
  clusterId?: string;
};

type MigrationDetailsLinkArgs = {
  clusterId?: string;
  migrationId: string;
};

const getDynamicMigrationDetailsRoutePath = () =>
  `${PRODUCT_BASE_PATHS.automation}/external-clusters/:clusterId/${containerLiveMigrationRouteSegment}/:migrationId`;

const getClusterId = (clusterId?: string): string => {
  const resolvedClusterId = clusterId ?? getClusterIdFromLink();

  if (!resolvedClusterId) {
    console.error('Cluster id is required');
    captureMessage('Cluster id is required');
    return '';
  }

  return resolvedClusterId;
};

export const makeContainerLiveMigrationLink = (
  { clusterId }: ContainerLiveMigrationLinkArgs = {},
  queryParams: URLSearchParams = new URLSearchParams()
) => {
  const path = generatePath(getDynamicContainerLiveMigrationRoutePath(), {
    clusterId: getClusterId(clusterId),
  });

  const mergedParams = new URLSearchParams(queryParams);
  const currentParams = new URLSearchParams(window.location.search);

  currentParams.forEach((value, key) => {
    if (PERSISTENT_QUERY_PARAMS.includes(key) && !mergedParams.has(key)) {
      mergedParams.set(key, value);
    }
  });

  return mergedParams.size ? `${path}?${mergedParams.toString()}` : path;
};

export const makeMigrationDetailsLink = (
  { clusterId, migrationId }: MigrationDetailsLinkArgs,
  queryParams: URLSearchParams = new URLSearchParams()
) => {
  const path = generatePath(getDynamicMigrationDetailsRoutePath(), {
    clusterId: getClusterId(clusterId),
    migrationId,
  });

  const mergedParams = new URLSearchParams(queryParams);
  const currentParams = new URLSearchParams(window.location.search);

  currentParams.forEach((value, key) => {
    if (PERSISTENT_QUERY_PARAMS.includes(key) && !mergedParams.has(key)) {
      mergedParams.set(key, value);
    }
  });

  return mergedParams.size ? `${path}?${mergedParams.toString()}` : path;
};
